module.exports = __webpack_public_path__ + "static/img/ikonaMikrofonDisabled-OFF.0a443074.png";